export default class Error
{
  constructor() {
    this.message = ''
    this.errors = []
  }
}